<ejs-dialog #multiAssetUploadDialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false"
            (close)="onCancel()"
            (open)="onOpen($event)">
  <ng-template #header>
    <div>{{'i18n.domain.assets.asset-storage.edit-asset-storage.assign-asset' | translate}}</div>
  </ng-template>

  <ng-template #content>
    <div class="row">
      <div [ngClass]="{'col-4': !isUploading, 'col-12': isUploading}">
        <app-multi-upload-uploader #multiUploadUploaderComponent
                                   [isAssetStorageMode]="false"
                                   [uploadEditForms]="productAssetUploadEditorForms"
                                   [productNumbers]="productNumbers"
                                   (fileForEditSelected)="fileForEditSelected($event)"
                                   (uploadSuccessful)="onUploadSuccessful()">
        </app-multi-upload-uploader>
      </div>
      @if (selectedProductAssetUploadEditorForm && !isUploading) {
        <div class="col-8">
          <app-asset-edit-tab-group #assetEditTabGroupComponent
                                    [assetUploadEditorForm]="selectedProductAssetUploadEditorForm"
                                    [ngClass]="{'zoom-uploader': isUploading}"
                                    (setScreenSize)="setScreenSize($event)">
          </app-asset-edit-tab-group>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-flat"
              (click)="onCancel()">
        {{'i18n.shared.cancel' | translate}}
      </button>
      @if (!isUploading) {
        <button class="e-control e-btn e-lib e-primary e-flat"
                (click)="onSave()"
                [disabled]="!canSave">
          {{'i18n.shared.save' | translate}}
        </button>
      }
    </ng-container>
  </ng-template>
</ejs-dialog>
